<div class="divisor20"></div>
<div>
    <div class="divisor8"></div>
    <div class="row">
        <div class="col-lg-12 col-lg-12 col-sm-12 col-12">
            <!-- Hijos -->
            <div class="row">
                <div class="col-12">
                    <span class="labelDescripcionGris">Horario del colaborador</span>
                </div>
            </div>

            <div class="divisor20" *ngIf="!disabled"></div>
            <div class="row" *ngIf="!disabled">
                <div class="col-12">
                    <div class="panelBotonesFiltro mixto">
                        <button  class="btn boton botonXS" (click)="Modal()">
                            <span class="fa fa-plus"></span>
                            <span> {{'Agregar'}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="divisor16"></div>

            <div class="row">
                <div class="col-12">
                    <!-- datos -->
                    <dx-data-grid
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [showColumnHeaders]="true"                        
                        >

                        <dxi-column *ngIf="!disabled"
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center">

                        </dxi-column>
                        <dxi-column
                            dataField="ciclo"
                            caption="Ciclo">
                        </dxi-column>
                        <dxi-column
                            dataField="semestre"
                            caption="Semestre">
                        </dxi-column>
                        <dxi-column
                            dataField="lunesentrada"
                            caption="LUN ent.">
                        </dxi-column>
                        <dxi-column
                            dataField="lunessalida"
                            caption="LUN sal.">
                        </dxi-column>
                        <dxi-column
                            dataField="martesentrada"
                            caption="MAR ent.">
                        </dxi-column>
                        <dxi-column
                            dataField="martessalida"
                            caption="MAR sal.">
                        </dxi-column>
                        <dxi-column
                            dataField="miercolesentrada"
                            caption="MIE ent.">
                        </dxi-column>
                        <dxi-column
                            dataField="miercolessalida"
                            caption="MIE sal.">
                        </dxi-column>
                        <dxi-column
                            dataField="juevesentrada"
                            caption="JUE ent.">
                        </dxi-column>
                        <dxi-column
                            dataField="juevessalida"
                            caption="JUE sal.">
                        </dxi-column>
                        <dxi-column
                            dataField="viernesentrada"
                            caption="VIE ent.">
                        </dxi-column>
                        <dxi-column
                            dataField="viernessalida"
                            caption="VIE sal.">
                        </dxi-column>
                        <dxi-column
                            dataField="sabadoentrada"
                            caption="SAB ent.">
                        </dxi-column>
                        <dxi-column
                            dataField="sabadosalida"
                            caption="SAB sal.">
                        </dxi-column>
                        <dxi-column
                            dataField="domingoentrada"
                            caption="DOM ent.">
                        </dxi-column>
                        <dxi-column
                            dataField="domingosalida"
                            caption="DOM sal.">
                        </dxi-column>
                        <dxi-column
                            dataField="fecha"
                            caption="Última modif."
                            dataType="date"
                            format="dd/MM/yyyy">
                        </dxi-column>
                        <dxi-column
                            dataField="usuario"
                            caption="Modificado por">
                        </dxi-column>

                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <a matTooltip="Editar" class="tablaBoton edit" (click)="Editar(cell.data)">
                                <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                            </a>
                            <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)">
                                <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>

                    </dx-data-grid>
                </div>
            </div>

            <div class="divisor48"></div>

            <div class="row">
                <div class="col-12">
                    <!-- datos -->
                    <dx-data-grid
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable2"
                        [showColumnHeaders]="true"
                        >

                        <dxi-column *ngIf="!disabled"
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center">

                        </dxi-column>
                        <dxi-column
                            dataField="ciclo"
                            caption="Ciclo">
                        </dxi-column>
                        <dxi-column
                            dataField="semestre"
                            caption="Semestre">
                        </dxi-column>
                        <dxi-column
                            dataField="horarioespecial"
                            caption="Horario especial">
                        </dxi-column>
                        <dxi-column
                            dataField="fecha"
                            caption="Última modif."
                            dataType="date"
                            format="dd/MM/yyyy">
                        </dxi-column>
                        <dxi-column
                            dataField="usuario"
                            caption="Modificado por">
                        </dxi-column>

                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <a matTooltip="Editar" class="tablaBoton edit" (click)="Editar(cell.data)">
                                <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                            </a>
                            <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)">
                                <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>

                    </dx-data-grid>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">

        <div class="contenido">
            <!-- Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{(entidad.colaboradorhorarioid == 0 ? 'Agregar' : 'Editar')}}
                </div>
            </div>
            <div class="modalContenido">
                <!-- datos -->
                <div>
                    <div class="divisor8"></div>
                    <div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <dropdownCustom [titulo]="'Ciclo'"
                                    [(ngModel)]="entidad.cicloid"
                                    [opciones]="SelCiclo"
                                    [valorName]="'cicloid'"
                                    [displayValor]="'nombre'"
                                    [errorActivo]="errorActivo"
                                    [buscar]="false"
                                    ></dropdownCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <dropdownCustom [titulo]="'Semestre'"
                                    [(ngModel)]="entidad.semestreid"
                                    [opciones]="SelSemestre"
                                    [valorName]="'semestreid'"
                                    [displayValor]="'nombre'"
                                    [buscar]="false"
                                    ></dropdownCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                                <checkBoxCustom [titulo]="'Horario especial'" [alineacion]="1" [(ngModel)]="entidad.especial"></checkBoxCustom>
                            </div>
                        </div>
                        <div class="row" *ngIf="!entidad.especial">
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Lunes entrada'" [(ngModel)]="entidad.lunesentrada" [verError]="entidad.lunessalida ? true : false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Lunes salida'" [(ngModel)]="entidad.lunessalida" [verError]="entidad.lunesentrada  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Martes entrada'" [(ngModel)]="entidad.martesentrada" [verError]="entidad.martessalida  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Martes salida'" [(ngModel)]="entidad.martessalida" [verError]="entidad.martesentrada  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Miercoles entrada'" [(ngModel)]="entidad.miercolesentrada" [verError]="entidad.miercolessalida  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Miercoles salida'" [(ngModel)]="entidad.miercolessalida" [verError]="entidad.miercolesentrada  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Jueves entrada'" [(ngModel)]="entidad.juevesentrada" [verError]="entidad.juevessalida  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Jueves salida'" [(ngModel)]="entidad.juevessalida" [verError]="entidad.juevesentrada  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Viernes entrada'" [(ngModel)]="entidad.viernesentrada" [verError]="entidad.viernessalida  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Viernes salida'" [(ngModel)]="entidad.viernessalida" [verError]="entidad.viernesentrada  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Sabado entrada'" [(ngModel)]="entidad.sabadoentrada" [verError]="entidad.sabadosalida  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Sabado salida'" [(ngModel)]="entidad.sabadosalida" [verError]="entidad.sabadoentrada  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Domingo entrada'" [(ngModel)]="entidad.domingoentrada" [verError]="entidad.domingosalida  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                <timePickerCustom [titulo]="'Domingo salida'" [(ngModel)]="entidad.domingosalida" [verError]="entidad.domingoentrada  ? true:false" [errorActivo]="errorActivo"></timePickerCustom>
                            </div>
                        </div>
                        <div class="row" *ngIf="entidad.especial">
                            <div class="col-lg-8 col-md-10 col-sm-12 col-12">
                                <textareaCustom [titulo]="'Horario especial'" [(ngModel)]="entidad.horarioespecial" [verError]="entidad.especial ? true:false">  [errorActivo]="errorActivo"</textareaCustom>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <!-- editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            {{'Guardar' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
